import infra from '@/util/infra'
import arquivoUtil from '@/util/arquivoUtil'
import util from '@/util'

const obterEnderecoImagem = (imageStream) => {
  const codigoBase64 = (util.valorVazio(imageStream.codigoBase64) ? '' : imageStream.codigoBase64)
  let src = 'data:image/png;base64,' + codigoBase64
  if (!util.valorVazio(imageStream.urlExterna)) {
    src = imageStream.urlExterna
  }
  return src
}

const obterCodigoBase64DoObjetoStream = async (imageStream) => {
  let codigoFotoUsuario = (util.valorVazio(imageStream.codigoBase64) ? null : imageStream.codigoBase64)
  if (codigoFotoUsuario === null && !util.valorVazio(imageStream.urlExterna)) {
    const resultadoDownload = infra.downloadDeArquivoViaCloud(imageStream.urlExterna)
    await resultadoDownload.then(async (resposta) => {
      const arquivoFoto = resposta.data
      codigoFotoUsuario = await arquivoUtil.converterBlobParaBase64(arquivoFoto)
    })
  }
  return codigoFotoUsuario
}

export default {
  obterEnderecoImagem,
  obterCodigoBase64DoObjetoStream
}
